import * as moment from 'moment';
import {extendMoment} from 'moment-range';
import {createRoot} from 'react-dom/client';
import {IoProvider} from 'socket.io-react-hook';
import 'react-resizable/css/styles.css';

import './index.css';
import './styles/index.scss';

import {configure as configureHttp} from './config/http';
import configurei18n from './locale/configurei18n';
import {NotifierContainer} from 'components';
import {envConfig} from 'config';
import {analyticsService} from 'services';
import {portalMutationTracer} from 'utils';

import App from './App';
import * as serviceWorker from './serviceWorker';
import './moment-locale';

extendMoment(moment);

configurei18n();
configureHttp();
analyticsService.init(envConfig.gaMeasurementId);
portalMutationTracer.start();

const root = createRoot(document.getElementById('root'));
root.render(
    <IoProvider>
        {/* <React.StrictMode> */}
        <NotifierContainer />
        <App />
        {/* </React.StrictMode> */}
    </IoProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
